import React, { useEffect } from 'react';
import Header from '../../components/common/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlug } from '@fortawesome/free-solid-svg-icons';
import ManualBling from '../../components/IntegracoesManualBling';
import './stylesmanualecommerce.css';

const ManualEcommerce = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const voltarInicio = () => {
        window.location.href = 'https://www.informezz.com.br/#/home';
    };

    return (
        <>
            <Header />

            <div className="me-page">

                {/* Hero Banner */}
                <div className="me-hero">
                    <div className="me-hero__content">
                        <div className="me-hero__icon">
                            <FontAwesomeIcon icon={faPlug} />
                        </div>
                        <h1 className="me-hero__title">Integração E-Commerce • MASC</h1>
                        <p className="me-hero__subtitle">Manual de integração com Bling</p>
                    </div>
                </div>

                {/* Conteúdo */}
                <div className="me-wrapper">

                    {/* Botão voltar */}
                    <button className="me-back-btn" onClick={voltarInicio}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Voltar à Página Inicial</span>
                    </button>

                    <div className="me-card">
                        <ManualBling />
                    </div>

                    <button className="me-back-btn me-back-btn--bottom" onClick={voltarInicio}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Voltar à Página Inicial</span>
                    </button>

                </div>
            </div>
        </>
    );
};

export default ManualEcommerce;
